module.exports = __webpack_public_path__ + "img/download-02.e92e7392.svg";